import * as moment from 'moment-timezone';
/**
 * Get a list of date info based on the date range provided
 * Monday is the first day of the week according to the ISO 8601 standard
 * @param totalDays a total number of days to get, starting from Monday this week; default 14 days = 2 weeks
 * @param skippedWeekdays list of weekdays to skip in response; 1 being Monday and 7 being Sunday
 * @param startDate the date picked to retrieve the starting of a week; default is today
 */
export var getDaysFromStartOfWeek = function (totalDays, skippedWeekdays, startDate) {
    if (totalDays === void 0) { totalDays = 14; }
    var startD = startDate ? startDate : new Date();
    var skippedList = skippedWeekdays ? skippedWeekdays : [];
    var result = [];
    for (var i = 1; i <= totalDays; i++) {
        var momentDay = moment(startD).isoWeekday(i);
        var currentWeekDay = momentDay.isoWeekday();
        var shouldSkipTheDay = skippedList.includes(currentWeekDay);
        if (!shouldSkipTheDay) {
            result.push({
                formattedDate: momentDay.format('YYYY-MM-DD'),
                day: momentDay.format('D'),
                weekdayName: momentDay.format('ddd'),
            });
        }
    }
    return result;
};
export var getCalendarMonthYearTitle = function (totalDisplayedDays, startDate) {
    if (totalDisplayedDays === void 0) { totalDisplayedDays = 14; }
    var startD = moment(startDate).isoWeekday(1);
    var endD = moment(startDate).isoWeekday(totalDisplayedDays);
    if (startD.isSame(endD, 'month') && startD.isSame(endD, 'year')) {
        return startD.format('MMMM YYYY');
    }
    else if (startD.isBefore(endD, 'month') && startD.isSame(endD, 'year')) {
        return startD.format('MMMM') + " - " + endD.format('MMMM YYYY');
    }
    return startD.format('MMMM YYYY') + " - " + endD.format('MMMM YYYY');
};
export var getTodayDateTimeInSelectedTimeZone = function (timezone) {
    var options = {
        timeZone: timezone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23', // use h23 hour system to display midnight with 00:00
    };
    // use en-CA locale to return a date string in format[YYYY-MM-DD, hh:mm:ss]
    var today = new Intl.DateTimeFormat('en-CA', options).format().split(', ');
    return {
        date: today[0],
        time: today[1],
    };
};
export var getIsWithin24HrsOrAfterDeliveryTime = function (officeCurrentDateTime, targetDeliveryTime) {
    // both officeCurrentDateTime and targetDeliveryTime are formated YYYY-MM-DDThh:mm:ss with no timezone
    // moment adds a default timezone (UTC) to both here but it does not affect our calculation result
    return moment("" + officeCurrentDateTime).isSameOrAfter(moment("" + targetDeliveryTime).subtract(1, 'days'));
};
// return true if there is at least one entry on any weekends (O: Sunday, 6: Saturday)
export var getHasGoEntriesOnWeekends = function (entries) {
    return entries.some(function (goEntry) {
        var _a;
        var dayOfWeek = moment(goEntry === null || goEntry === void 0 ? void 0 : goEntry.date).day();
        return (dayOfWeek === 0 || dayOfWeek === 6) && ((_a = goEntry === null || goEntry === void 0 ? void 0 : goEntry.entries) === null || _a === void 0 ? void 0 : _a.length) > 0;
    });
};
